import { Form } from 'react-bootstrap';
import type { RefObject } from 'react';
import type ReactEChartsCore from 'echarts-for-react/lib/core';

type CustomLegentProps = {
  chartRef: RefObject<ReactEChartsCore | null>;
  name: string;
  color: string;
};

const CustomLegent = ({ chartRef, name, color }: CustomLegentProps) => {
  const genId = `x${Math.floor(Math.random() * 1000000)}`;
  return (
    <div className="d-flex align-items-center">
      <Form.Check.Input
        onChange={() =>
          chartRef.current?.getEchartsInstance().dispatchAction({
            type: 'legendToggleSelect',
            name: name
          })
        }
        type="checkbox"
        id={genId}
        defaultChecked
        style={{ borderColor: color, marginBottom: '-3px' }}
        className="dot mt-0 shadow-none remove-checked-icon rounded-circle cursor-pointer"
      />
      <Form.Check.Label
        htmlFor={genId}
        className="fs--2 mb-n1 text-700 cursor-pointer "
      >
        {name}
      </Form.Check.Label>
      <style>{`#${genId}:checked{background-color:${color};}`}</style>
    </div>
  );
};

export default CustomLegent;
